import { useTranslation } from 'react-i18next';

import { Alert } from '../UI/Alert';

import type { Props } from './types';

export function ErrorAlert({ message, size, ...rest }: Props) {
  const { t } = useTranslation();

  const isLarge = size === 'large';

  const getMessage = () => {
    if (message) {
      return message;
    }

    if (isLarge) {
      return t('error.large.title');
    }

    return t('error.small.message');
  };

  return (
    <Alert
      description={isLarge ? t('error.large.message') : undefined}
      message={getMessage()}
      size={size}
      type="info"
      {...rest}
    />
  );
}
